export enum InsuredRelationEnum {
  INSURED = 'INSURED',
  INSURED2 = 'INSURED2',
}
